import dayjs from "dayjs";

const validityCheck = (orderData, order_id) => {
  const orderDateTime = dayjs(orderData?.orderTime || orderData?.timestamp, "YYYY-MM-DD HH:mm:ss");
  const systemDateTime = dayjs();

  const diffHoursDifferentDate = parseInt(process.env.REACT_APP_DIFF_HOURS_DIFFERENT_DATE) || 2;
  const diffHoursSameDate = parseInt(process.env.REACT_APP_DIFF_HOURS_SAME_DATE) || 3;

  const isSameDate = orderDateTime.isSame(systemDateTime, "day");

  if (!isSameDate) {
    const hoursDiff = systemDateTime.diff(orderDateTime, "hours");
    if (hoursDiff > diffHoursDifferentDate) {
      // BUG-1971 follow-up: this used to be silent (the diagnostic here was removed as
      // "leftover" in 351fcdd9). A false return here silently skips ALL printing (invoice
      // and KOT) for the order with no other trace, so the hoursDiff/threshold that
      // triggered it is the one piece of information that can confirm or rule out a
      // till clock/timezone problem the next time this fires in production.
      console.warn(`[validityCheck] Order ${order_id} failed validity check (different date): ${hoursDiff}h old, threshold ${diffHoursDifferentDate}h. Print will be skipped.`);
      return false;
    }
  } else {
    const hoursDiff = systemDateTime.diff(orderDateTime, "hours");
    if (hoursDiff > diffHoursSameDate) {
      console.warn(`[validityCheck] Order ${order_id} failed validity check (same date): ${hoursDiff}h old, threshold ${diffHoursSameDate}h. Print will be skipped.`);
      return false;
    }
  }

  return true;
};

export default validityCheck;
